/**
 * The Infrastruktur page's one read, on the shared {@link opsClient}. Cross-shop and free of
 * merchant data: no shop grant, no reason.
 */
import type { OpsInfrastructureDto } from '../../../../libs/api-client/src/generated/models';
import { opsClient } from './ops-api';

// Re-exported from the generated client rather than restated here — see `support-api.ts`.
export type {
  OpsCeilingPartDto as OpsCeilingPart,
  OpsConnectionSourceDto as OpsConnectionSource,
  OpsDatabaseDto as OpsDatabase,
  OpsInfrastructureDto as OpsInfrastructure,
  OpsInfrastructureLevel,
  OpsInfrastructureSnapshotDto as OpsInfrastructureSnapshot,
  OpsLoadBalancerDto as OpsLoadBalancer,
  OpsNodeDto as OpsNode,
  OpsRedisDto as OpsRedis,
} from '../../../../libs/api-client/src/generated/models';

/** Query key of the snapshot. */
export const INFRASTRUCTURE_QUERY_KEY = ['ops-infrastructure'] as const;

/** The latest snapshot the collector stored. */
export async function fetchInfrastructure(): Promise<OpsInfrastructureDto> {
  const { data } = await opsClient().getOpsInfrastructure();
  return data;
}
